import React, { useState } from "react";
import Big from "big.js";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { PortfolioDialog } from "../PortfolioDialog/PortfolioDialog";
import { calculateAssetsTotalPercentage } from "../../../../utils";
import { useCurrentPortfolio } from "../../../../store";
import { SGrid, SButton } from "./styles";

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedPortfolio } = useCurrentPortfolio();
  const [open, setOpen] = useState(false);

  const assetsTotalPercentage = calculateAssetsTotalPercentage(
    selectedPortfolio?.assets || null
  );

  const handleClick = (): void => {
    if (
      Big(assetsTotalPercentage).gt(100) ||
      Big(assetsTotalPercentage).lt(100)
    ) {
      setOpen((state) => !state);
    } else {
      navigate("../analysis");
    }
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return location.pathname !== "/analysis" ? (
    <SGrid>
      <PortfolioDialog open={open} onClose={handleClose} />
      <SButton
        endIcon={
          <ArrowForwardIosIcon style={{ fontSize: 14, marginLeft: 8 }} />
        }
        onClick={handleClick}
      >
        {t("portfolioEditorAnalysis")}
      </SButton>
    </SGrid>
  ) : null;
};
